import { useService } from 'react-reservice';

import { forgotPasswordService } from './service';

export const useForgotPassword = () => useService(forgotPasswordService, (context) => context);
